import {ref,reactive,watch,onMounted} from 'vue'
import {useStore} from 'vuex'
import validateFormUnbound from '../../foundation/js/validators/validateForm'

export default {
    name: "receiptComponent",
    props:{
        insertedComment: String,
        insertedRef: String
    },
    setup(props){
        const store = useStore()
        const userAcceptance = ref(false)
        const formName = 'comments'

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        const formConfig = reactive([
            {
                label: getLabel('reference_id'),
                name: 'externalReference',
                required: false,
                type: 'text',
                canNotBeDisabled: true,
                value: props.insertedRef || '',
                valid: false,
                validator: null,
                small: false 
            },
            {
                label: getLabel('comment'),
                name: 'comment',
                required: false,
                type: 'textarea',
                value: props.insertedComment || '',
                valid: false,
                validator: null,
                small: false 
            }
        ])

        const validateForm = validateFormUnbound.bind(null,formConfig,formName,store)

        const toggleUserAcceptance = function(){
            if(store.state.ecom.user_accepted_terms){
                store.commit('ecom/user_refuses_terms')
                return true
            }
            store.commit('ecom/user_accepts_terms')
        }

        watch(formConfig,validateForm,{deep:true})

        onMounted(()=>{        
            store.commit('ecom/register_checkout_form',{
                name: formName
            })
            validateForm()
        })

        return {
            userAcceptance,
            toggleUserAcceptance,
            formConfig
        }
    }
}